<template>
  <div id="participaciones" class="bgazul">
    <section class="bannerprincipal">
      <div class="">
        <div class="row">
          <div class="col-12 col-md-12 offset-md-0 h-100">
            <div class="py-5"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="">
      <div class="container pt-5">
        <div class="row text-center">
          <!-- <div class="row text-center" v-if="tickets3 != null"> -->

          <div class="col-12 oscuro blanco pb-5">
            <div class="row">
              <div class="col-12 pb-5">
                <span class="azul fXXG fanta"> GANADORES </span>
              </div>
              <div class="col-12 py-5 azul fG">Próximamente</div>

              <!-- <div class="col-12 py-5 azul">
                <table class="tablaazul" border="1" cellpadding="0" cellspacing="0" width="1146">
                  <colgroup>
                    <col width="57" />
                    <col width="155" />
                    <col width="934" />
                  </colgroup>
                  <tbody>
                    <tr height="22">
                      <td height="22" dir="LTR" width="57">LUGAR</td>
                      <td dir="LTR" width="155">NOMBRE</td>
                      <td dir="LTR" width="934">INCENTIVO</td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">1</td>
                      <td dir="LTR">LUIS PÉREZ</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">2</td>
                      <td dir="LTR">HUGO PAEZ</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">3</td>
                      <td dir="LTR">MARTÍN CHÁVEZ</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">4</td>
                      <td dir="LTR">GABRIEL CHAVIRA</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">5</td>
                      <td dir="LTR">SALVADOR ESTRADA</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">6</td>
                      <td dir="LTR">HÉCTOR PEDROZA</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">7</td>
                      <td dir="LTR">ERICK JUÁREZ</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">8</td>
                      <td dir="LTR">JESÚS MONTILLA</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">9</td>
                      <td dir="LTR">RAÚL MACÍAS</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                    <tr height="22">
                      <td height="22" dir="LTR">10</td>
                      <td dir="LTR">JOSÉ CASTILLO</td>
                      <td dir="LTR">
                        VIAJE TODO INCLUIDO A PLAYAS MEXICANAS. VALOR TOTAL DEL
                        VIAJE $69,600.00 M.N. IVA E IMPUESTOS DE VIAJE INCLUIDO.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->

              <div class="col-12 py-5">&nbsp;</div>
              <div class="col-12 py-5">&nbsp;</div>
              <div class="col-12 py-5">&nbsp;</div>
            </div>
          </div>

          <!-- <div class="col-12 pt-5 pb-3">
            <router-link
              to="/dashboard"
              type="button"
              class="btnaction w-100 fG bold px-5"
            >
              REGRESAR
            </router-link>

           
          </div> -->
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import AOS from "aos";
import { mapState } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 25;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: true,
      time: 0,
      time_txt: "",
      suma_puntos: 0,
      suma_time: 0,
      puntos_ultimo_juego: 0,
      tickets2: [],
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      ahora: null,
      semana_corriente: "",
      multiplicador: 2,
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });
    console.log({ userProfile: this.userProfile });
    //this.getTickets();
  },
  methods: {
    getMultiplicador(puntos) {
      let multiplicador = 1;
      return multiplicador * puntos;
    },
    getTiempoFormato(time) {
      return this.secondsToHms(time);
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async getTickets2() {
      console.log("llamando tickets");
      this.$store.dispatch("showLoader", true);

      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .where("status", "in", [
          "cerrado",
          "cerrado en otro ticket",
          "por validar",
          "valido",
          //"invalido",
        ])
        .get();

      this.tickets3 = [];
      let thes = this;
      this.suma_puntos = 0;
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;

        try {
          //ticket.score = parseInt(ticket.score) * this.multiplicador;

          ticket.score = ticket.puntos;

          // let participaciones = ticket.participaciones;

          // participaciones.forEach((obj) => {
          //   if (ticket.cashi === true){
          //     ticket.score += this.multiplicador * obj.puntos;
          //   }else{
          //     ticket.score += obj.score;
          //   }
          // });
        } catch {
          //
        }

        thes.tickets3.push(ticket);
      });
      this.tickets3 = this.tickets3.sort(this.custom_sort);
      console.log({ tickets3_misparticipaciones: this.tickets3 });

      this.setResumen();

      this.$store.dispatch("showLoader", false);
    },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    async setResumen() {
      if (this.tickets3.length > 0) {
        this.ultimo_ticket = this.tickets3[this.tickets3.length - 1];
        this.puntos_ultimo_juego = this.ultimo_ticket.puntos;
      }
      console.log({ ultimo: this.ultimo_ticket });
      console.log({ ultimo_id: this.ultimo_ticket.id });

      // console.log({ multiplicador: this.tickets });
      //console.log({ userProfile: this.userProfile });
      let multiplicador = 1;

      await this.getAhora();
      this.semana_corriente = this.getNumSemana(this.ahora);
      //console.log({tengoahora: this.ahora});

      let week = this.getSemana(this.ahora);
      //console.log(moment().add(2, "days"));
      //console.log({ weekahora: week });
      let suma_puntos = 0;
      let suma_time = 0;
      this.tickets3.forEach((element) => {
        //console.log({ elem: element.created_on.seconds });
        let date = moment.unix(element.created_on.seconds).format("L");
        //console.log(date);
        //console.log(moment(date).week());
        let temp_week = moment(date).add(2, "days").week();
        //console.log({ weektemp: temp_week });
        //if (week == temp_week) {
        try {
          if (element.puntos != undefined)
            suma_puntos = suma_puntos + parseInt(element.puntos);
        } catch (err) {
          //
        }
        // suma_time = suma_time + parseInt(element.time);
        //}
      });

      this.suma_puntos = suma_puntos;
      this.suma_time = this.secondsToHms(suma_time);
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    getNumSemana(fecha) {
      let semana = parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;

      return semana;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
